import { render, staticRenderFns } from "./ResultsNewMessage.vue?vue&type=template&id=6ea12a0d&"
import script from "./ResultsNewMessage.vue?vue&type=script&lang=js&"
export * from "./ResultsNewMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports